
import './Teenused.css';
import {useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Button, Navbar, Container, Nav, NavDropdown, Card, Row, Col, Image, Table, ThemeProvider } from 'react-bootstrap';

export default function Hero() {

    return (
      <div className='main'>
        <Container>

        
          <Container style={{marginBottom:"2.5rem", fontWeight:"500", textAlign:"start", color:"#43ACE7",}}>
           <h1 style={{color:"#43ACE7", textAlign:"start"}}>
            <strong >Ortodontiline diagnostika</strong>
          </h1>
            <p style={{color:"#43ACE7", fontWeight:"500", textAlign:"start"}}></p>
          <div style={{display:"flex"}}>
            <div style={{width:"50%"}}>
                                <p style={{ textAlign: "start"}}>
        Põhjalik esmane hindamine, mille käigus teeme kliinilised fotod, digitaalsed jäljendid iTero scanner abil ning analüüsime koos patsiendiga röntgenpilte, et saada terviklik ülevaade hambumusest ja lõualuude arengust.
Lisaks hindame näo profiili, hambumuse funktsiooni, ruumipuudust või -ülejääki ning vajadusel teeme tsefalomeetrilise analüüsi ja ravisimulatsiooni, et koostada täpne, individuaalne raviplaan.
      </p>
      <p>
        Meie kliinikus on hammastest mudelite tegemisel kasutusel iTero scanner – kaasaegne digitaalne suusisene skanner, mis võimaldab võtta täpseid 3D jäljendeid kiiresti ja mugavalt, ilma ebamugava jäljendmassita.
      </p>
      <p>
        Patsiendi jaoks peamised eelised:
      </p>
      <ul>
        <li>
          Mugavus – ei ole ebameeldivat massi suus, sobib ka tundlikuma refleksiga patsientidele
        </li>
                <li>
          Kiirus – skaneerimine on kiire ja protsess sujuv
        </li>
                <li>
          Täpsus – väga detailne 3D mudel parema raviplaneerimise jaoks
        </li>
                <li>
          Visuaalsus – patsient näeb oma hambaid ja võimalikku ravitulemust ekraanil
        </li>
                <li>
          Kaasaegsus – digitaalne töövoog vähendab vigade riski ja parandab ravikogemust


        </li>
      </ul>
            </div>

        <div className='diagnostika-photo' style={{width:"50%"}}></div>
          </div>


      </Container>
          </Container>

        </div>
    );
}